import { render } from "./ActionsNewMessageModal.vue?vue&type=template&id=581014f3"
import script from "./ActionsNewMessageModal.vue?vue&type=script&lang=js"
export * from "./ActionsNewMessageModal.vue?vue&type=script&lang=js"

import "./ActionsNewMessageModal.vue?vue&type=style&index=0&id=581014f3&lang=scss"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__